/* Kalen & Rose - Klaviyo list subscription
   Subscribes popup / footer / quiz signups to the "Email List" (XGFyY7)
   with consent via Klaviyo's client subscribe API, so the 15% welcome
   flow actually triggers (instead of only creating a silent profile).
   Public company id is safe to expose; it is required client-side. */
(function () {
  'use strict';
  var COMPANY_ID = 'TARKN5';
  var LIST_ID = 'XGFyY7';

  function subscribe(email, source, props) {
    if (!email || email.indexOf('@') === -1) return Promise.resolve();
    var profileAttrs = { email: email };
    if (props) profileAttrs.properties = props;
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'Website',
            profile: { data: { type: 'profile', attributes: profileAttrs } }
          },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      })
    }).catch(function () {});
  }
  window.krKlaviyoSubscribe = subscribe;

  function wrap() {
    // Welcome popup
    if (typeof window.submitPopup === 'function') {
      var origPopup = window.submitPopup;
      window.submitPopup = function (e) {
        try {
          var el = document.getElementById('popupEmail');
          if (el) subscribe(el.value, 'Welcome Popup', { 'Lead Source': 'Welcome Popup' });
        } catch (_) {}
        return origPopup.call(this, e);
      };
    }
    // Skincare quiz email capture
    if (typeof window.krClaimResult === 'function') {
      var origClaim = window.krClaimResult;
      window.krClaimResult = function (e) {
        try {
          var el = document.getElementById('qrEmail');
          if (el) subscribe(el.value, 'Skincare Quiz', { 'Lead Source': 'Skincare Quiz' });
        } catch (_) {}
        return origClaim.call(this, e);
      };
    }
    // Footer email signup (capture phase so we read the value before it clears)
    var ff = document.getElementById('footerEmailForm');
    if (ff) {
      ff.addEventListener('submit', function () {
        try {
          var el = document.getElementById('footerEmail');
          if (el) subscribe(el.value, 'Footer Signup', { 'Lead Source': 'Footer Email Signup' });
        } catch (_) {}
      }, true);
    }
  }

  if (document.readyState === 'complete') wrap();
  else window.addEventListener('load', wrap);
})();
